import React, { createContext, useState, useEffect } from 'react';

// Create the language context
export const LanguageContext = createContext();

// Define all translations here
const translations = {
    en: {
        // Header
        home: 'Home',
        menu: 'Menu',
        contact: 'Contact',
        orderNow: 'Order Now',
        whatsappUs: 'WhatsApp Us',
        callUs: 'Call Us',

        // Hero
        tiffinService: 'Tiffin Service for',
        typingWords: [
            "Authentic",
            "Homemade",
            "Flavorful",
            "Fresh",
            "Delicious"
        ],
        heroDescription: 'BerlinTiffin delivers authentic home-cooked meals with locally-sourced ingredients for a taste of home in the heart of the city.',
        bookNow: 'Book Now',
        newCustomer: 'New Customer? 15% OFF your first order!',
        lovedBy: 'Loved by',
        happyCustomers: 'happy customers',

        // Stats
        reviewRating: 'Review Rating',
        ordersDelivered: 'Orders Delivered',
        localRecipes: 'Local Recipes',
        yearsInBerlin: 'Years in Berlin',

        // Menu
        ourMenu: 'Our Menu',
        menuDescription: 'Authentic Indian flavors made with locally-sourced ingredients. Our menu changes seasonally to ensure the freshest experience.',
        vegetarianCurries: 'Vegetarian Curries',
        nonVegCurries: 'Non-Veg Curries',
        breadsRice: 'Breads & Rice',
        filters: 'Filters',
        showAll: 'Show All',
        vegetarianOnly: 'Vegetarian Only',
        spicyDishes: 'Spicy Dishes',
        vegetarian: 'Vegetarian',
        spicy: 'Spicy',
        viewOrder: 'View Order',
        yourOrder: 'Your Order',
        cartEmpty: 'Your cart is empty',
        total: 'Total:',
        checkout: 'Checkout',
        deliveryInformation: 'Delivery Information',
        freeDelivery: 'Free delivery for orders over €25 within Berlin.',
        estimatedDelivery: 'Estimated delivery time: 30-45 minutes',
        deliveryHours: 'Delivery hours: 11:30 AM - 9:30 PM',
        moreDetails: 'More details',
        showLess: 'Show less',
        addToOrder: 'Add',
        allergens: 'Allergens:',

        // Menu items descriptions
        mutterPaneer: {
            name: 'Mutter Paneer',
            desc: 'Cottage cheese and green peas in a creamy tomato sauce',
            longDesc: 'Tender green peas and soft paneer cubes simmered in a rich tomato-based gravy with aromatic Indian spices.'
        },
        alooDum: {
            name: 'Aloo Dum',
            desc: 'Baby potatoes in a thick, tangy gravy',
            longDesc: 'Baby potatoes slow-cooked in a flavorful gravy made with tomatoes, onions, and traditional Indian spices.'
        },
        palakPaneer: {
            name: 'Palak Paneer',
            desc: 'Cottage cheese cubes in a creamy spinach sauce',
            longDesc: 'Fresh spinach purée cooked with homemade paneer cheese, garlic, and ginger for a nutritious and delicious dish.'
        },
        bhindiFry: {
            name: 'Bhindi Fry',
            desc: 'Okra stir-fried with aromatic spices and onions',
            longDesc: 'Crispy okra pieces stir-fried with onions and spices for a delicious dry vegetable dish.'
        },
        chickenCurry: {
            name: 'Chicken Curry',
            desc: 'Tender chicken pieces in an aromatic curry sauce',
            longDesc: 'Succulent pieces of chicken simmered in a rich gravy made with onions, tomatoes, and traditional Indian spices.'
        },
        muttonKotha: {
            name: 'Mutton Kotha',
            desc: 'Slow-cooked goat meat in a rich, spiced gravy',
            longDesc: 'Tender goat meat slow-cooked with onions, yogurt, and a special blend of whole spices for a deep, complex flavor.'
        },
        roti: {
            name: 'Roti',
            desc: 'Whole wheat flatbread, freshly made',
            longDesc: 'Traditional whole wheat flatbread cooked on a tawa (griddle), perfect for scooping up curries.'
        },
        paratha: {
            name: 'Paratha',
            desc: 'Flaky, layered wheat flatbread',
            longDesc: 'Flaky layered flatbread made with whole wheat flour and ghee, cooked until golden brown.'
        },
        friedRice: {
            name: 'Fried Rice',
            desc: 'Basmati rice stir-fried with vegetables and spices',
            longDesc: 'Fragrant basmati rice stir-fried with vegetables and mild Indian spices.'
        },

        // Booking Modal
        bookTiffin: 'Book Your Tiffin',
        fillDetails: 'Fill in the details below to place your order',
        details: 'Details',
        confirm: 'Confirm',
        name: 'Name',
        deliveryAddress: 'Delivery Address',
        date: 'Date',
        time: 'Time',
        selectTime: 'Select time',
        numberOfPeople: 'Number of People',
        selectMenuType: 'Select Menu Type',
        specialInstructions: 'Special Instructions',
        dietaryPreferences: 'Any dietary restrictions, preferences, or special requests?',
        orderSummary: 'Order Summary',
        people: 'People:',
        menuType: 'Menu Type:',
        notes: 'Notes:',
        confirmationNote: 'We\'ll confirm your order details shortly after submission.',
        back: 'Back',
        next: 'Next',
        placeOrder: 'Place Order'
    },
    de: {
        // Header
        home: 'Startseite',
        menu: 'Speisekarte',
        contact: 'Kontakt',
        orderNow: 'Jetzt Bestellen',
        whatsappUs: 'WhatsApp Uns',
        callUs: 'Ruf Uns An',

        // Hero
        tiffinService: 'Tiffin-Service für',
        typingWords: [
            "Authentisch",
            "Hausgemacht",
            "Würzig",
            "Frisch",
            "Köstlich"
        ],
        heroDescription: 'BerlinTiffin liefert authentische hausgemachte Mahlzeiten mit lokalen Zutaten für einen Geschmack von zu Hause im Herzen der Stadt.',
        bookNow: 'Jetzt Buchen',
        newCustomer: 'Neukunde? 15% RABATT auf Ihre erste Bestellung!',
        lovedBy: 'Geliebt von',
        happyCustomers: 'zufriedenen Kunden',

        // Stats
        reviewRating: 'Bewertung',
        ordersDelivered: 'Bestellungen',
        localRecipes: 'Lokale Rezepte',
        yearsInBerlin: 'Jahre in Berlin',

        // Menu
        ourMenu: 'Unsere Speisekarte',
        menuDescription: 'Authentische indische Aromen aus lokalen Zutaten. Unsere Speisekarte ändert sich saisonal, um stets die frischesten Gerichte anzubieten.',
        vegetarianCurries: 'Vegetarische Currys',
        nonVegCurries: 'Fleisch Currys',
        breadsRice: 'Brot & Reis',
        filters: 'Filter',
        showAll: 'Alle anzeigen',
        vegetarianOnly: 'Nur Vegetarisch',
        spicyDishes: 'Scharfe Gerichte',
        vegetarian: 'Vegetarisch',
        spicy: 'Scharf',
        viewOrder: 'Bestellung anzeigen',
        yourOrder: 'Ihre Bestellung',
        cartEmpty: 'Ihr Warenkorb ist leer',
        total: 'Gesamt:',
        checkout: 'Zur Kasse',
        deliveryInformation: 'Lieferinformationen',
        freeDelivery: 'Kostenlose Lieferung für Bestellungen über 25€ innerhalb Berlins.',
        estimatedDelivery: 'Geschätzte Lieferzeit: 30-45 Minuten',
        deliveryHours: 'Lieferzeiten: 11:30 - 21:30 Uhr',
        moreDetails: 'Mehr Details',
        showLess: 'Weniger anzeigen',
        addToOrder: 'Hinzufügen',
        allergens: 'Allergene:',

        // Menu items descriptions
        mutterPaneer: {
            name: 'Mutter Paneer',
            desc: 'Hüttenkäse und grüne Erbsen in einer cremigen Tomatensauce',
            longDesc: 'Zarte grüne Erbsen und weiche Paneer-Würfel in einer reichhaltigen Tomatensauce mit aromatischen indischen Gewürzen.'
        },
        alooDum: {
            name: 'Aloo Dum',
            desc: 'Kleine Kartoffeln in einer dicken, würzigen Soße',
            longDesc: 'Kleine Kartoffeln, langsam gekocht in einer schmackhaften Soße aus Tomaten, Zwiebeln und traditionellen indischen Gewürzen.'
        },
        palakPaneer: {
            name: 'Palak Paneer',
            desc: 'Hüttenkäsewürfel in einer cremigen Spinatsauce',
            longDesc: 'Frisches Spinatpüree mit hausgemachtem Paneer-Käse, Knoblauch und Ingwer für ein nahrhaftes und köstliches Gericht.'
        },
        bhindiFry: {
            name: 'Bhindi Fry',
            desc: 'Okra mit aromatischen Gewürzen und Zwiebeln angebraten',
            longDesc: 'Knusprige Okrastücke mit Zwiebeln und Gewürzen für ein köstliches, trockenes Gemüsegericht.'
        },
        chickenCurry: {
            name: 'Chicken Curry',
            desc: 'Zarte Hähnchenstücke in einer aromatischen Currysoße',
            longDesc: 'Saftige Hähnchenstücke in einer reichhaltigen Soße aus Zwiebeln, Tomaten und traditionellen indischen Gewürzen.'
        },
        muttonKotha: {
            name: 'Mutton Kotha',
            desc: 'Langsam gegartes Ziegenfleisch in einer reichhaltigen, gewürzten Soße',
            longDesc: 'Zartes Ziegenfleisch, langsam gekocht mit Zwiebeln, Joghurt und einer speziellen Mischung aus ganzen Gewürzen für einen tiefen, komplexen Geschmack.'
        },
        roti: {
            name: 'Roti',
            desc: 'Vollkorn-Fladenbrot, frisch zubereitet',
            longDesc: 'Traditionelles Vollkornfladenbrot auf einem Tawa (Grillplatte) gebacken, perfekt zum Aufnehmen von Currys.'
        },
        paratha: {
            name: 'Paratha',
            desc: 'Blättriges, geschichtetes Weizenfladenbrot',
            longDesc: 'Blättriges Fladenbrot aus Vollkornmehl und Ghee, goldbraun gebacken.'
        },
        friedRice: {
            name: 'Gebratener Reis',
            desc: 'Basmati-Reis mit Gemüse und Gewürzen angebraten',
            longDesc: 'Duftender Basmati-Reis mit Gemüse und milden indischen Gewürzen angebraten.'
        },

        // Booking Modal
        bookTiffin: 'Tiffin bestellen',
        fillDetails: 'Füllen Sie die folgenden Angaben aus, um Ihre Bestellung aufzugeben',
        details: 'Details',
        confirm: 'Bestätigen',
        name: 'Name',
        deliveryAddress: 'Lieferadresse',
        date: 'Datum',
        time: 'Zeit',
        selectTime: 'Zeit auswählen',
        numberOfPeople: 'Personenanzahl',
        selectMenuType: 'Menütyp auswählen',
        specialInstructions: 'Besondere Anweisungen',
        dietaryPreferences: 'Diätvorschriften, Vorlieben oder besondere Wünsche?',
        orderSummary: 'Bestellübersicht',
        people: 'Personen:',
        menuType: 'Menütyp:',
        notes: 'Notizen:',
        confirmationNote: 'Wir bestätigen Ihre Bestelldetails kurz nach dem Absenden.',
        back: 'Zurück',
        next: 'Weiter',
        placeOrder: 'Bestellung aufgeben'
    }
};

export const LanguageProvider = ({ children }) => {
    // Check browser language and localStorage
    const getBrowserLanguage = () => {
        const savedLanguage = localStorage.getItem('language');
        if (savedLanguage && (savedLanguage === 'en' || savedLanguage === 'de')) {
            return savedLanguage;
        }

        const browserLang = navigator.language || navigator.userLanguage;
        return browserLang.startsWith('de') ? 'de' : 'en';
    };

    const [language, setLanguage] = useState(getBrowserLanguage());

    // Save language preference to localStorage
    useEffect(() => {
        localStorage.setItem('language', language);
        // Update html lang attribute for accessibility
        document.documentElement.lang = language;
    }, [language]);

    return (
        <LanguageContext.Provider value={{ language, setLanguage, translations }}>
            {children}
        </LanguageContext.Provider>
    );
};

export default LanguageProvider;